<template>
  <Dialog :visible="visible" class="irinox-dialog-light after-sales after-sales-visibility" :modal="true" 
              :closable="false" :dismissableMask="true" :style="{width: '95vw', maxWidth: '600px'}" :draggable="false"
              @update:visible="updateVisible" @show="show">
    
    <template #header>
      <img src="assets/irinox/icons/arrow_back.svg" @click="updateVisible(false)" :alt="$t('common.arrow_left')"/>
      <div>{{$t('factory.visibility.title')}}</div>
    </template>

    <div class="irinox-dialog-light-content layout-content">

      <div class="visibility-company">{{ companyName }}</div>

      <div class="visibility-email p-mb-3">{{ email }}</div>

      <div class="irinox-form after-sales" >
        <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-6">
                  <label>{{ $t('factory.visibility.access') }}</label>
                  <div class="p-field-checkbox p-my-1">
                      <RadioButton v-model="form.type" class="p-mr-2" inputId="access1" name="access" value="FULL" 
                        :class="{'p-invalid':v$.form.type.$invalid && submitted}" />
                      <p v-html="$t('factory.visibility.access_all')"></p>
                  </div>
                  <div class="p-field-checkbox p-my-1">
                      <RadioButton v-model="form.type" class="p-mr-2" inputId="access2" name="access" value="NONE" 
                        :class="{'p-invalid':v$.form.type.$invalid && submitted}" />
                      <p v-html="$t('factory.visibility.access_none')"></p>
                  </div>
                  <div class="p-field-checkbox p-my-1">
                      <RadioButton v-model="form.type" class="p-mr-2" inputId="access3" name="access" value="PARTIAL" 
                        :class="{'p-invalid':v$.form.type.$invalid && submitted}" />
                      <p v-html="$t('factory.visibility.access_partial')"></p>
                  </div>
              </div>
              <div class="p-field p-col-6">
                  <label>{{ $t('factory.visibility.price') }}</label>
                  <div class="p-field-checkbox p-my-1">
                      <RadioButton v-model="form.price" class="p-mr-2" inputId="price1" name="price" value="NONE" 
                        :class="{'p-invalid':v$.form.price.$invalid && submitted}" :disabled="form.type==='NONE'"/>
                      <p v-html="$t('factory.visibility.price_none')"></p>
                  </div>
                  <div class="p-field-checkbox p-my-1">
                      <RadioButton v-model="form.price" class="p-mr-2" inputId="price2" name="price" value="EUR" 
                        :class="{'p-invalid':v$.form.price.$invalid && submitted}" :disabled="form.type==='NONE'" />
                      <p v-html="$t('factory.visibility.price_eur')"></p>
                  </div>
                  <div class="p-field-checkbox p-my-1">
                      <RadioButton v-model="form.price" class="p-mr-2" inputId="price3" name="price" value="USD" 
                        :class="{'p-invalid':v$.form.price.$invalid && submitted}" :disabled="form.type==='NONE'" />
                      <p v-html="$t('factory.visibility.price_usd')"></p>
                  </div>
              </div>
              <div class="p-field p-col-6" v-if="form.type === 'PARTIAL'">
                  {{ $t('factory.visibility.families') }}
                  <div v-for="(option, index) in level1Options" :key="index" class="p-field-checkbox p-my-1">
                      <Checkbox v-model="form.docTreeKeys" :inputId="'family'+index" :value="option.value" class="p-mr-2"
                        :class="{'p-invalid':v$.form.docTreeKeys.$invalid && submitted}"/>
                      <label :for="'family'+index">{{ option.label }}</label>
                  </div>
              </div>
          </div>
      </div>




    </div>


    <template #footer>
      <Button :label="$t('factory.visibility.button')" @click="saveVisibility(!v$.form.$invalid)"/>
    </template>
  </Dialog>

  <IrinoxDialogDark :visible="dialog.error" 
    mode="error" 
    :message="$t('factory.visibility.dialog_error')"
    :life="3000" 
    @update:visible="dialog.error = $event" />
  <IrinoxDialogDark :visible="dialog.success" 
    mode="success" 
    :message="$t('factory.visibility.dialog_success')"
    :life="3000" 
    @update:visible="dialog.success = $event" />

</template>

<script>
import { required, requiredIf } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import IrinoxDialogDark from '../IrinoxDialogDark.vue';
import AfterSalesService from '../../service/AfterSalesService';
import { mapGetters } from 'vuex';
export default {
    components: {
      IrinoxDialogDark
    },
    setup: () => ({ v$: useVuelidate() }),
    emits: ['update:visible'],
    props: {
      visible: Boolean,
      companyName: String,
      email: String,
    },
    data() {
        return {
          form: {
            type: 'NONE',
            price: null,
            docTreeKeys: [],
          },
          dialog: {
            error: false,
            success: false,
          },
          submitted: false,
        };
    },
    computed: {
      ...mapGetters({
        personaltoken: 'userdata/personaltoken',
        docTreeRaw: 'afterSales/docTreeRaw',
        docTreeRawDate: 'afterSales/docTreeRawDate',
      }),
      level1Options() {
        let options = [];
        this.docTreeRaw.forEach(item => {
          if(item.level1 && !options.find(opt => opt.value === item.level1)) {
            options.push({label: (item.level1Translation || item.level1) + (item.domain!='STANDARD' ? ' ('+ item.domain +')' : ''), value: item.level1});
          }
        });
        options.sort((a,b) => a.label.localeCompare(b.label));
        return options;
      }
    },
    validations() {
      return {
          form: {
            type: {
                required
            },
            price: {
                required
            },
            docTreeKeys: {
                required: requiredIf(function() {
                  return this.form.type==='PARTIAL'
                }),
            }
          }
      }
    },
    watch: {
      '$i18n.locale': 'loadDocTree',
      'form.type': 'typeChange',
    },
    created() {
      this.afterSalesService = new AfterSalesService();
    },
    mounted() {
      if(this.$config.afterSalesEnabled()) {
        this.loadDocTree();
      } 
    },
    methods: {
      updateVisible(value) {
        if(!value) {
          this.form = {
            type: 'NONE',
            price: 'NONE',
            docTreeKeys: [],
          };
        }
        this.$emit("update:visible", value);
      },
      show() {
        this.getVisibility();
      },
      getVisibility() {
        this.afterSalesService.getVisibility(this.personaltoken, this.email)
            .then((data) => {
              if(data.code=="200") {
                if(data.body) {
                  this.form.type = data.body.type;
                  this.form.price = data.body.price || 'NONE';
                  this.form.docTreeKeys = data.body.docTreeKeys || [];
                } else {
                  this.form.type = 'NONE';
                  this.form.price = 'NONE';
                  this.form.docTreeKeys = [];
                }
              } else {
                console.error(JSON.stringify(data));
                this.dialog.error = true;
              }
              })
            .catch(error => {
              console.error("ERROR "+error);
              this.dialog.error = true;
            });
      },
      saveVisibility(isFormValid) {
        this.submitted = true;
        if (!isFormValid) {
          return;
        }
        let formCopy = this.$functions.clone(this.form);
        if(formCopy.price === 'NONE') {
          formCopy.price = null;
        }
        if(formCopy.type !== 'PARTIAL') {
          formCopy.docTreeKeys = [];
        }
        this.afterSalesService.saveVisibility(this.personaltoken, this.email, formCopy)
            .then((data) => {
              if(data.code=="200") {
                this.dialog.success = true;
                this.updateVisible(false);
              } else {
                console.error(JSON.stringify(data));
                this.dialog.error = true;
              }
              })
            .catch(error => {
              console.error("ERROR "+error);
              this.dialog.error = true;
            });
      },
      loadDocTree() {
        // if(this.docTreeRaw.length>0 && this.docTreeRawDate && this.$moment().diff(this.$moment(this.docTreeRawDate), 'hours') < 1) {
        //   console.log("Load docTree from store");
        // } else {
        //   console.log("Load docTree from API");
          this.afterSalesService.getDocTree(this.personaltoken, this.$functions.language(this.$i18n.locale))
            .then((data) => {
              if(data.code=="200") {
                this.$store.commit('afterSales/docTreeRaw', data.body);
              } else {
                console.error(JSON.stringify(data));
                this.$store.commit('afterSales/docTreeRaw', []);
                this.dialog.error = true;
              }
              })
            .catch(error => {
              console.error("ERROR "+error);
              this.$store.commit('afterSales/docTreeRaw', []);
              this.dialog.error = true;
            });
        // }
      },
      typeChange() {
        if(this.form.type==='NONE') {
          this.form.price = 'NONE';
        }
      }
    }
}
</script>

<style>

</style>